﻿declare var CKEDITOR: any;
import $ from 'jquery';

declare global {
  interface JQuery {
    richtext:(option) => any;
  }
}

export class RichText {
  static get wireup(): string {
    return '[data-richtext]';
  }

  constructor(private $textArea: JQuery) {
    var id = $textArea.attr("id");
    CKEDITOR.replace(id);
  }
}

($ => {
  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data('rustig.richtext');

      if (!data) {
        data = new RichText($this);
        $this.data('rustig.richtext', data);
      }
      if (typeof option == 'string') {
        data[option]();
      }
    });
  }

  $.fn.richtext = Plugin;

})($);